import React from "react";
import EntityTable from "../EntityTable";
import {
  anchorConnectionColumnId,
  renderRowUpdateAction,
} from "../../common/TableUtils";
import {
  personConnectionColumns,
  personConnectionFilterSpec,
} from "../../common/entities/PersonConnectionColumns";
import { PersonConnection, PersonConnectionFilters } from "../../types/personConnection";
import PersonConnectionDialog from "../modals/PersonConnection/PersonConnectionDialog";
import { ConnectionFormDataController } from "../../controllers/formController";
import { Person } from "../../types/person";
import usePersonConnectionQuery from "../../hooks/query/connections/usePersonConnectionQuery";
import { MRT_ColumnDef } from "material-react-table";
import useServerFilters from "../../hooks/useServerFilters";

interface PersonConnectionTableProps {
  columns?: MRT_ColumnDef<PersonConnection, any>[];
  filters?: Partial<PersonConnectionFilters>;
  controller: ConnectionFormDataController<PersonConnection, Person, Person>;
}

const PersonConnectionTable: React.FC<PersonConnectionTableProps> = ({
  columns = personConnectionColumns,
  controller,
  filters = {},
}) => {
  const {
    serverFilters,
    entityTableFilterProps,
    pagination,
    setPagination,
  } = useServerFilters(filters, personConnectionFilterSpec);
  const { useFetchConnectedEdges } = usePersonConnectionQuery();
  const { anchorEntity, direction, openEditDialog } = controller;
  const { data, isLoading, errorMessage } = useFetchConnectedEdges(
    anchorEntity._id,
    direction,
    {
      bodyParams: serverFilters,
      externalPagination: pagination,
      externalSetPagination: setPagination,
    }
  );

  const renderRowActions = renderRowUpdateAction<PersonConnection>((row) =>
    openEditDialog(row._key)
  );

  return (
    <>
      <EntityTable
        loading={isLoading}
        error={errorMessage}
        columns={columns}
        hiddenColumnIds={[anchorConnectionColumnId(direction)]}
        renderRowActions={renderRowActions}
        enableRowActions
        data={data?.data || []}
        pagination={pagination}
        manualPagination={true}
        onPaginationChange={setPagination}
        totalRowCount={data?.total || 0}
        manualFiltering
      {...entityTableFilterProps}
      />
      <PersonConnectionDialog controller={controller} />
    </>
  );
};

export default PersonConnectionTable;
